// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3KNa-","buttons":"PendingPaymentAlert_buttons__3dW6H"};